var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrow"},[_c('div',{staticClass:"arrow__image"},[_c('img',{attrs:{"alt":"","src":_vm.arrow}})])])}
var staticRenderFns = []

export { render, staticRenderFns }